import { forwardRef } from 'react'
import type { Icon, IconProps } from '@phosphor-icons/react'

/**
 * Phosphor-compatible wrapper around BrandMonogram so it can be passed to
 * components that expect a Phosphor `Icon` (e.g. our internal NavLink and
 * the Navbar mobile tab icons, which receive `weight`/`size` props).
 *
 * `weight` and `mirrored` are accepted but ignored — BrandMonogram is a
 * fixed SVG lockup, not a variable-weight glyph.
 */
const BrandMonogramIcon: Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, color = 'currentColor', className, style, ...rest }, ref) => {
    const numericSize =
      typeof size === 'number' ? size : parseInt(String(size), 10) || 16
    return (
      <svg
        ref={ref}
        className={className}
        style={style}
        viewBox="0 0 16 16"
        width={numericSize}
        height={numericSize}
        fill="none"
        aria-hidden="true"
        {...rest}
      >
        <text
          x="2"
          y="6.5"
          fontFamily="Plus Jakarta Sans, sans-serif"
          fontWeight="800"
          fontSize="5.5"
          fill={color}
        >
          B
        </text>
        <line
          x1="6"
          y1="10.5"
          x2="10"
          y2="5.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity="0.55"
        />
        <text
          x="14"
          y="14"
          fontFamily="Plus Jakarta Sans, sans-serif"
          fontWeight="800"
          fontSize="5.5"
          fill={color}
          textAnchor="end"
        >
          N
        </text>
      </svg>
    )
  }
)

BrandMonogramIcon.displayName = 'BrandMonogramIcon'

export default BrandMonogramIcon
